@if (list) {
  <table-fixed-header-search-collapse
    id-table="maintenance-control-plan-group-action-proposed-errors-id"
    [header]="header"
    [checkedObjects]="checked"
    [data]="list"
    [getValue]="getData"
    >
  </table-fixed-header-search-collapse>
}